import PropTypes from 'prop-types';
import Layout from 'components/Layout';
import Card from 'components/Card';
import Loading from 'components/Loading';
import Tags from 'components/Tags';
// import { projects } from 'data/projects';
// import { tags as tagsData } from 'data/tags';
import { projects, tags as tagsData } from '@garlink/bd-pkg-portfolio';

export default function PortfolioPage({ data, tags, route }) {
    const error = null;

    return (
        <Layout route={route} section="portfolio" seo={{ title: 'Portfolio' }}>
            <section className={`section has-background-white`}>
                <div className="container has-text-centered">
                    <h1 className="title is-unselectable has-text-primary mb-6">Portfolio</h1>
                    <hr />
                    <p className="subtitle has-text-gray">
                        Here are a selection of some of my work.
                    </p>

                    <Tags data={tags} />

                    <div className="container has-text-left pt-5">
                        {!data && <Loading />}

                        {error && (
                            <h2 className="subtitle has-text-danger">Oops. Failed to load...</h2>
                        )}

                        <div className={`columns is-multiline`}>
                            {!error &&
                                data &&
                                data.map((item, index) => (
                                    <div
                                        key={item.id}
                                        className={`column is-full-mobile is-half-tablet is-one-third-desktop is-one-third-widescreen is-one-third-fullhd`}
                                    >
                                        <Card data={item} cover={false} />
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className={`section has-background-white`}>
                <div className="container has-text-centered">
                    <h2 className="title is-unselectable has-text-primary mb-6">Search by tag</h2>
                    <hr />
                    <Tags data={tags} />
                </div>
            </section>
        </Layout>
    );
}

PortfolioPage.propTypes = {
    data: PropTypes.array,
    tags: PropTypes.array,
    route: PropTypes.string,
};

export async function getStaticProps({ params }) {
    return { props: { data: projects, tags: tagsData } };
}
